import { Accordion, Card, Flex, Text } from "@mantine/core";
import { CAR_WEIGHT } from "@/utils/constants";
import CardHeader from "./CardHeader";
import ListRow from "./ListRow";

export default function CarListCard() {
  return (
    <Card>
      <CardHeader title="차량 제원 정보" />
      <Card.Section>
        <Accordion radius={0} variant="filled">
          {CAR_WEIGHT.map((x) => {
            return (
              <Accordion.Item
                value={x.value}
                style={{ borderTop: "1px solid #eaecef" }}
                key={x.value}
              >
                <Accordion.Control
                  icon={<img src={`/img/car/${x.value}.png`} alt={x.label} width={50} />}
                >
                  {x.label}
                </Accordion.Control>
                <Accordion.Panel>
                  <Card>
                    <Card.Section>
                      <img src={`/img/car/${x.value}.png`} alt={x.label} width={"100%"} />
                    </Card.Section>
                    <ListRow cat="최대적재량(t)" val={`${x.ton}톤`} />
                    <ListRow cat="적재함 크기" val={`${x.x} × ${x.y} × ${x.z}`} />
                    <Flex mt="xs" justify="flex-end">
                      <Text size="xs" c="dimmed">
                        폭 × 길이 × 최대높이(m)
                      </Text>
                    </Flex>
                  </Card>
                </Accordion.Panel>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </Card.Section>
    </Card>
  );
}
